import { useChannel } from "./ws/useChannel";
import useQuery, { useRevalidate } from "./useQuery";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";

const PATH = "/users/profile" as const;
export const useUser = () => {
  const revalidate = useRevalidate();

  const user = useQuery(PATH).body;
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH);
    },
    [revalidate],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "user_profile", userId: String(user.id) }, callback, true);
  return user;
};

export type User = ReturnType<typeof useUser>;
export type ProjectRole = User["roles"]["projects"][0]["role"];
export type SourceRole = User["roles"]["sources"][0]["role"];
export type GlobalRole = Exclude<User["roles"]["global"], null>;
